import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  authorData: null,
  authorPosts: null
};

// *************************** Fetch Author Info ****************************
const fetchAuthorInfoStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchAuthorInfoSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, authorData: action.authorData, loading: false };
};

const fetchAuthorInfoFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Author Posts *************************
const fetchAuthorPostsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchAuthorPostsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, authorPosts: action.authorPosts, loading: false };
};

const fetchAuthorPostsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_AUTHOR_INFO_START]: fetchAuthorInfoStart,
  [Types.FETCH_AUTHOR_INFO_FAILURE]: fetchAuthorInfoFailure,
  [Types.FETCH_AUTHOR_INFO_SUCCESS]: fetchAuthorInfoSuccess,

  [Types.FETCH_AUTHOR_POSTS_START]: fetchAuthorPostsStart,
  [Types.FETCH_AUTHOR_POSTS_FAILURE]: fetchAuthorPostsFailure,
  [Types.FETCH_AUTHOR_POSTS_SUCCESS]: fetchAuthorPostsSuccess
};

// Create and Export Reducer
export const authorInfoReducer = createReducer(INITIAL_STATE, HANDLERS);
